import gql from 'graphql-tag';

export class CommentsFragments {
  static reply = gql`
    fragment dealroomReplyFragment on DealroomCommentReply {
      id
      participantId
      text
      richText
      status
      createdAt
      updatedAt
      reads {
        participantId
        timestamp
      }
    }
  `;

  static textSelection = gql`
    fragment dealroomTextSelectionFragment on DealroomTextSelection {
      anchor
      head
      type
    }
  `;

  static editorSelection = gql`
    fragment dealroomSelectionFragment on DealroomEditorSelection {
      editorBlockId
      rowId
      cellId
      nodeId
      sectionId
      crossVersionSelectionId
      editorBlockVersion
      textSelection {
        ...dealroomTextSelectionFragment
      }
      content
      detachedFromContent
      detachedFromVersion
    }
    ${this.textSelection}
  `;

  static comment = gql`
    fragment dealroomCommentFragment on DealroomContextualComment {
      id
      crossVersionSelectionId
      richText
      text
      status
      createdAt
      updatedAt
      participantId
      editorSelection {
        ...dealroomSelectionFragment
      }
      replies {
        ...dealroomReplyFragment
      }
      reads {
        participantId
        timestamp
      }
    }
    ${this.editorSelection}
    ${this.reply}
  `;
}
